// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ChartBarIcon } from '@moia-dev/pace-icons'
import { useQueryState } from 'nuqs'
import { FleetPerformanceOverviewAreaRoutes } from './FleetPerformanceOverviewAreaRoutes'

export const FleetPerformanceOverviewAreaNavigationIcon = ChartBarIcon

export const FleetPerformanceOverviewAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  const [fleetId] = useQueryState('fleet_id', { defaultValue: '' })

  const to = fleetId
    ? `${FleetPerformanceOverviewAreaRoutes.route}?fleet_id=${fleetId}`
    : FleetPerformanceOverviewAreaRoutes.route

  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={to}
      Icon={ChartBarIcon}
    />
  )
}
